module.exports = [{"id":1,"val":"敌袭"},{"id":2,"val":"神秘商人"},{"id":3,"val":"神灵邂逅"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/random_event_current.json
// module id = ZJXf
// module chunks = 1